import router from './router'
import store from './store'

import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth'

NProgress.configure({ showSpinner: false }) // NProgress 配置

router.beforeEach((to, from, next) => {
	NProgress.start() // start progress bar
	// next()

	// 判定用户是否登录
	const hasToken = getToken()

	if (hasToken) {
		if (to.path === '/login') {
			next({ path: '/' })
			NProgress.done()
		} else {
			// 判定用户是否获取了用户信息
			const hasGetUserInfo = store.getters.realName
			if (hasGetUserInfo) {
				next()
			} else {
				store
					.dispatch('user/getUserInfo')
					.then(() => {
						next()
					})
					.catch(() => {
						store.dispatch('user/logout').then(() => {
							next(`/login?redirect=${to.path}`)
						})
					})
			}
		}
	} else {
		/* has no token*/
		if (to.path === '/login') {
			next()
		} else {
			if (to?.meta?.whiteListed) {
				next()
			} else {
				// 部分页面需要登录才能访问，没有登录的用户跳转到登录页面，登录成功后跳转到之前的页面
				// next(`/login?redirect=${to.path}`)
				next(`/login`)
			}
		}
		NProgress.done()
	}
})

router.afterEach(() => {
	NProgress.done() // finish progress bar
})
